import React, { useState } from 'react';

const ButtonOutline = ({ label, icon: IconComponent, customStyles, palette, size, disabled, onClick }) => {
  const buttonClassName = `button-outline-${size} button-outline-${palette}`;
  
  return (
    <button className={buttonClassName} style={{ ...customStyles }} disabled={disabled} onClick={onClick}>
      {IconComponent && <IconComponent/>}
      <p className='text'>{label}</p>
    </button>
  );
};

export default ButtonOutline;